import { useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

import PersonalDefaultPage from "./PersonalDefaultPage";
import { OnestBoldBig, OnestBoldDefault } from "../../components/styled/TextComponents";
import { color_grey_light, color_red_default, color_white } from "../../constants/colors";
import { useEffect, useState, useCallback } from "react";
import axios from "axios";
import Config from "../../Config";
import { setAllLessons } from "../../store/LessonsProgramSlice";
import ArrowIconLeft from "../../components/icons/ArrowIconLeft";
import ZoomOutIcon from "../../components/icons/ZoomOutIcon";
import { useWindowDimensions } from "../../utils";
import { get_user } from "../../components/blocks/profileUpdating/dataUpdating/ProfileDataUpdatingBlock";
import { setUser } from "../../store/UserSlice";
import ModalQuestionTwoAnswers from "../../components/blocks/ModalQuestionTwoAnswers";

import { v4 as uuidv4 } from 'uuid';
import { isDesktop } from "../../utilities/getDeviceType";
import { useI18n } from "../../i18n/I18nProvider";

const GoBackButton = () => {
    const navigate = useNavigate();

    return (
        <div style={{
            width: 35,
            height: 35,
            borderRadius: "50%",
            backgroundColor: color_white,
            color: color_red_default,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            cursor: "pointer"

        }} onClick={() => navigate(-1)}>
            <ArrowIconLeft
                style={{
                    marginRight: 5,
                }}

            />

        </div>
    )
}

const SearchBar = ({ searchValue, setSearchValue }) => {
    const { t } = useI18n();

    return (
        <div style={{
            position: "relative",
            width: "100%",
        }}>
            <input style={{
                height: 45,
                width: "100%",
                maxWidth: "100%",
                boxSizing: "border-box",
                backgroundColor: color_white,
                borderRadius: 10,
                fontSize: 16,
                border: `0px solid ${color_grey_light}`,
                paddingLeft: 50,
            }} placeholder={t("Введите запрос...")} value={searchValue} onChange={(event) => setSearchValue(event.target.value)}>
            </input>
            <div
                style={{
                    position: "absolute",
                    left: "15px", // Расположение иконки справа

                    top: "50%",
                    transform: "translateY(-50%)",
                    pointerEvents: "none", // Иконка не будет мешать клику по select
                }}
            >
                <ZoomOutIcon width={20} height={20} />
            </div>
        </div>
    )
}
const LessonGridBlock = ({ image, title, openPath, openInNewWindow }) => {
    const { height: screenHeight, width: screenWidth } = useWindowDimensions();



    return (
        <div
            role="link"
            tabIndex={0}
            onClick={() => openInNewWindow(openPath)}
            style={{ textDecoration: "none", color: "inherit", cursor: "pointer", outline: "none" }}
        >
            <div style={{
                width: screenWidth > 655 ? 228 : (screenWidth - 130) / 2,
                height: screenWidth > 655 ? 200 : "auto",
                border: 20,
                display: "flex",
                padding: screenWidth > 650 ? 20 : 10,
                flexDirection: "column",
                gap: screenWidth > 650 ? 20 : 10,
                backgroundColor: color_white,
                justifyContent: "space-between",
                alignContent: "center",
                borderRadius: screenWidth > 650 ? 20 : 15
            }}>
                <div style={{ display: "flex", justifyContent: "center" }}>
                    <img alt={image} style={{
                        width: screenWidth > 650 ? 218 : (screenWidth - 140) / 2,
                        height: screenWidth > 650 ? 141 : "auto",
                        border: 20,
                        borderRadius: screenWidth > 650 ? 20 : 10
                    }} src={image} />
                </div>

                <div style={{
                    display: "flex",
                    flexDirection: "row",
                    justifyContent: "space-between",
                }}>
                    <OnestBoldDefault>{title}</OnestBoldDefault>
                    {/* <BsEye style={{color: color_red_default, fontSize: 25}}/> */}
                </div>
            </div>
        </div>
    )
}
export const LevelLessonsPage = () => {
    const { t } = useI18n();
    const { width: screenWidth } = useWindowDimensions();
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const user = useSelector(state => state.user);
    const lessonsProgram = useSelector(state => state.lessonsProgram);
    const { levelId } = useParams();
    const levelData = ((typeof lessonsProgram === "object") && (lessonsProgram.length > 0)) ? (lessonsProgram.find(el => el.id === parseInt(levelId)) || {}) : {};
    const [searchValue, setSearchValue] = useState("")
    const [isShowModalToCloseLesson, setIsShowModalToCloseLesson] = useState('');
    //useEffect(() => {
    // axios.get(Config.BACKEND_ADDR + `/lessons`).
    //})

    const winWidth = screenWidth;


    const getLevels = () => {
        axios.get(Config.BACKEND_ADDR + "/levels/").then(res => {
            let levelsData = res.data
            levelsData.sort((a, b) => (a.name > b.name) ? 1 : ((b.name > a.name) ? -1 : 0))
            console.log("Levels: ", levelsData)
            dispatch(setAllLessons(levelsData.map(el => {
                return {
                    id: el.id,
                    level: el.name,
                    age: el.age_description,
                    image: Config.CLOUD_ADDR + "/" + el.image_path,
                    summary: el.description,
                    lessons: el.materials.map(material => {
                        return {
                            id: material.id,
                            image: material.image_path,
                            file: material.index_html_path,
                            level: material.level_id,
                            name: material.name,
                            completed: true,
                            index: material.index
                        }
                    })
                }
            })))
        })
    }

    useEffect(() => {
        if (typeof lessonsProgram !== "object" || lessonsProgram.length === 0) {
            getLevels();
        }
    }, [lessonsProgram])

    useEffect(() => {
        (async () => {
            console.log("NavBar user ", user)
            if (!user || Object.keys(user).length === 0) {
                try {
                    const data = await get_user();
                    dispatch(setUser(data));

                } catch (error) {
                    console.error('Error fetching user data:', error);
                    // Обработка ошибки, например, перенаправление на страницу входа
                    //navigate('/auth/login');
                }
            }
        })();
    }, [dispatch, user])

    useEffect(() => {
        let backendAddr = Config.BACKEND_ADDR + "/payments/getSubscriptionPeriod" // /api
        axios.get(backendAddr).then(response => {
            if (response.status === 200) {

                if (response.data.status === "not_paid") {
                    navigate("/billing/");
                }
            }
        }).catch(err => {
            console.warn("Ошибка проверки подписки в БД! ", err)
        })
    }, [navigate]);

    const openInNewWindow = useCallback(async (url) => {
        let uuid = await localStorage.getItem("uid")
        let canOpen = await axios.get(Config.BACKEND_ADDR + "/devices/is_open_lesson/" + uuid);
        if (canOpen.status !== 200) {
            console.warn("Lesson opening not allowed");
            return;
        }
        if (canOpen.data && canOpen.data.is_open_lesson === true) {
            const win = window.open(url, "_blank", "noopener,noreferrer");
            if (win) win.opener = null;
        } else {
            setIsShowModalToCloseLesson(url);
        }

    }, []);

    return (
        <PersonalDefaultPage>

            <ModalQuestionTwoAnswers
                type="question"
                h2={t("Урок открыт на другом устройстве")}
                p={t("Чтобы открыть уроки здесь, нужно завершить предыдущую сессию. Закрыть уроки на другом устройстве и открыть здесь?")}
                yesText={t("Открыть здесь")}
                noText={t("Остаться там")}
                isOpen={isShowModalToCloseLesson}
                onClose={() => setIsShowModalToCloseLesson('')}
                onAnswer={async (answer) => {
                    if (answer) {
                        // Закрыть урок на другом устройстве
                        let uuid = await localStorage.getItem("uid");
                        if (!uuid) {
                            uuid = uuidv4()
                            await localStorage.setItem("uid", uuid)
                        }
                        let openHere = await axios.post(Config.BACKEND_ADDR + "/devices/set_close_lesson", { device_id: uuid });
                        if (openHere.status === 200) {
                            console.log("Lesson closed on other device, opening here");
                            // Открыть здесь
                            const win = window.open(isShowModalToCloseLesson, "_blank", "noopener,noreferrer");
                            if (win) win.opener = null;
                        }
                    }
                    setIsShowModalToCloseLesson('');
                }}
            />

            <div
                style={{
                    width: "100%",
                    minWidth: 0,
                    flex: 1,
                    display: "flex",
                    flexDirection: "column",
                    gap: 24,
                    alignItems: "stretch",
                    boxSizing: "border-box",
                }}>
                    <div style={{
                        display: "flex",
                        flexDirection: "row",
                        alignItems: "center",
                        gap: 20,
                    }}>
                        <GoBackButton />
                        <OnestBoldBig>{levelData && Number.isFinite(Number(levelData.level)) ? `Level ${levelData.level}` : levelData.level}</OnestBoldBig>
                    </div>
                    <SearchBar
                        searchValue={searchValue}
                        setSearchValue={(newValue) => setSearchValue(newValue)}
                    />
                    <div style={{
                        display: "flex",
                        flexDirection: "row",
                        flexWrap: "wrap",
                        gap: winWidth >= 1280 && screenWidth < 1400 && isDesktop() ? 10 : 16,
                        width: "100%",
                        minWidth: 0,
                    }}>
                        {Array.isArray(lessonsProgram) && lessonsProgram.length > 0 && (() => {
                            const level = lessonsProgram.find(el => el.id === parseInt(levelId));
                            const lessons = Array.isArray(level?.lessons) ? [...level.lessons].sort((a, b) => a.index - b.index) : [];
                            return lessons
                                .filter(el => {
                                    if (searchValue === "" || !searchValue) return true;
                                    return el.name.toLowerCase().includes(searchValue.toLowerCase());
                                })
                                .map(el => (
                                    <LessonGridBlock
                                        image={Config.CLOUD_ADDR + '/speakid/' + el.image}
                                        title={el.name}
                                        openPath={Config.CLOUD_ADDR + '/speakid/' + el.file}
                                        openInNewWindow={openInNewWindow}
                                    />
                                ));
                        })()}
                    </div>
            </div>
        </PersonalDefaultPage>
    )
}